// extracted by mini-css-extract-plugin
module.exports = {"cardListWrapper":"styles_cardListWrapper__q17wQ","cardListWrapper_CardList":"styles_cardListWrapper_CardList__Q3QoF"};